module.exports = __webpack_public_path__ + "img/selected_container.9bd95c34.svg";